module.exports = __webpack_public_path__ + "static/img/11en.4924c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/11en.png
// module id = JIsJ
// module chunks = 0